import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";

import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "rc-time-picker/assets/index.css";
import TimePicker from "rc-time-picker";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import moment from "moment";
import { AiOutlineClose } from "react-icons/ai";
import { ToastError, ToastSuccess } from "../../Components/utils/ToastMessage";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const [parent] = useAutoAnimate(/* optional config */);
    const [slot2] = useAutoAnimate(/* optional config */);
    const [slot3] = useAutoAnimate(/* optional config */);
    const {
        handleSubmit,
        register,
        reset,
        formState: { errors },
    } = useForm();
    const [cities, setCities] = useState([]);
    const [Time, setTimes] = useState([
        // {
        //     FromTime: moment().format("HH:mm"),
        //     ToTime: moment().format("HH:mm"),
        // },
    ]);
    const [Time2, setTimes2] = useState([
        // {
        //     FromTime: moment().format("HH:mm"),
        //     ToTime: moment().format("HH:mm"),
        // },
    ]);
    const [Time3, setTimes3] = useState([
        // {
        //     FromTime: moment().format("HH:mm"),
        //     ToTime: moment().format("HH:mm"),
        // },
    ]);
    useEffect(() => {
        let formatSlots = (slots) => {
            const formattedSlots = slots?.map((slot) => {
                const [fromTime, toTime] = slot.Slot.split("-").map((time) =>
                    moment(time, "hh:mma").format("HH:mm")
                );
                return { FromTime: fromTime, ToTime: toTime };
            });
            return formattedSlots;
        };
        const getCitites = () => {
            Services.getcities("GET", null, token)
                .then((res) => {
                    if (res.Status === 1) {
                        setCities(res.Cities);
                        if (props.editable) {
                            let selectedSlot = props.categoryItems?.filter(
                                (item) => item.TimeSlotID == props.TimeSlotID
                            );
                            if (selectedSlot.length > 0) {
                                reset({
                                    City: selectedSlot[0].City,
                                    Type: selectedSlot[0].Type,
                                });
                                setTimes(formatSlots(selectedSlot[0].Today));
                                setTimes2(
                                    formatSlots(selectedSlot[0].Tommorrow)
                                );
                                setTimes3(
                                    formatSlots(selectedSlot[0].DayAfter)
                                );
                            }
                        }
                    } else if (res.Status === 0) {
                        ToastError(res.Message);
                        if (res.Message === "Token expired") {
                            Navigate("/");
                        }
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        };
        getCitites();

        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };

    const convertTo12HourFormat = (time24hr) => {
        const [hours, minutes] = time24hr.split(":");
        const parsedHours = parseInt(hours, 10);
        const period = parsedHours >= 12 ? "Pm" : "Am";
        const convertedHours = parsedHours % 12 || 12; // Handle midnight (00:00)
        const time12hr = `${convertedHours
            .toString()
            .padStart(2, "0")}:${minutes}${period}`;
        return time12hr;
    };
    const onSubmit = (data) => {
        let timeSlotsBody = Time.map((item) => ({
            Slot: `${convertTo12HourFormat(
                item.FromTime
            )}-${convertTo12HourFormat(item.ToTime)}`,
        }));
        let timeSlotsBody2 = Time2.map((item) => ({
            Slot: `${convertTo12HourFormat(
                item.FromTime
            )}-${convertTo12HourFormat(item.ToTime)}`,
        }));
        let timeSlotsBody3 = Time3.map((item) => ({
            Slot: `${convertTo12HourFormat(
                item.FromTime
            )}-${convertTo12HourFormat(item.ToTime)}`,
        }));

        if (props.editable) {
            Services.Update_Settings(
                "put",
                JSON.stringify({
                    Type: data.Type,
                    City: data.City,
                    Today: timeSlotsBody,
                    Tommorrow: timeSlotsBody2,
                    DayAfter: timeSlotsBody3,
                }),
                token,
                props.TimeSlotID
            )
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories(props.Navactive);

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else {
            Services.add_slot(
                "POST",
                JSON.stringify({
                    Type: data.Type,
                    City: data.City,
                    Today: timeSlotsBody,
                    Tommorrow: timeSlotsBody2,
                    DayAfter: timeSlotsBody3,
                }),
                token
            )
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories(props.Navactive);

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };
    const handleTimeChange = (index, event, Type, slotType) => {
        if (slotType === 1) {
            const newTime = [...Time];
            newTime[index][Type] = moment(event).format("HH:mm");
            setTimes(newTime);
        } else if (slotType === 2) {
            const newTime = [...Time2];
            newTime[index][Type] = moment(event).format("HH:mm");
            setTimes2(newTime);
        }
        if (slotType === 3) {
            const newTime = [...Time3];
            newTime[index][Type] = moment(event).format("HH:mm");
            setTimes3(newTime);
        }
    };
    const addslot = (type) => {
        if (type == 1) {
            setTimes([
                ...Time,
                {
                    FromTime: moment().format("HH:mm"),
                    ToTime: moment().format("HH:mm"),
                },
            ]);
        } else if (type == 2) {
            setTimes2([
                ...Time2,
                {
                    FromTime: moment().format("HH:mm"),
                    ToTime: moment().format("HH:mm"),
                },
            ]);
        } else if (type == 3) {
            setTimes3([
                ...Time3,
                {
                    FromTime: moment().format("HH:mm"),
                    ToTime: moment().format("HH:mm"),
                },
            ]);
        }
    };
    const removeSlot = (index, type) => {
        if (type == 1) {
            const newSlots = [...Time];
            newSlots.splice(index, 1);
            setTimes(newSlots);
        } else if (type == 2) {
            const newSlots = [...Time2];
            newSlots.splice(index, 1);
            setTimes2(newSlots);
        } else {
            const newSlots = [...Time3];
            newSlots.splice(index, 1);
            setTimes3(newSlots);
        }
    };
    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3> {props.editable ? "Update " : "Add"} Slot</h3>
                        <p>
                            {props.editable ? "Update Slot" : "Add Slot"} and
                            necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["form-control-city"]}>
                        <label htmlFor="Type">Type</label>
                        <select
                            {...register("Type", {
                                required: "this is required",
                            })}>
                            <option value="1">Grocery</option>
                            <option value="2">Service</option>
                        </select>
                        {errors?.Type && (
                            <span className={dashboardclasses["error"]}>
                                this is required
                            </span>
                        )}
                    </div>
                    <div className={dashboardclasses["form-control-city"]}>
                        <label htmlFor="City">City</label>
                        <select
                            {...register("City", {
                                required: "this is required",
                            })}>
                            {cities.map((item, index) => (
                                <option key={index} value={item.cityname}>
                                    {item.cityname}
                                </option>
                            ))}
                        </select>
                        {errors?.City && (
                            <span className={dashboardclasses["error"]}>
                                this is required
                            </span>
                        )}
                    </div>

                    <div
                        ref={parent}
                        className={dashboardclasses["Slots-Container"]}>
                        <button
                            Type="button"
                            onClick={() => {
                                addslot(1);
                            }}
                            className={dashboardclasses["add_slot"]}>
                            Add Slot
                        </button>
                        <label htmlFor="">Today</label>
                        {Time.map((item, index) => (
                            <div className={dashboardclasses["slots_input"]}>
                                <div className={dashboardclasses["slots_item"]}>
                                    <label htmlFor="">From Time</label>
                                    <TimePicker
                                        // onOpen={checkStartDate}
                                        value={moment(item.FromTime, "HH:mm")}
                                        placement={"topLeft"}
                                        defaultOpenValue={moment()}
                                        // focusOnOpen={true}
                                        minuteStep={5}
                                        allowEmpty={false}
                                        showSecond={false}
                                        onChange={(date) => {
                                            handleTimeChange(
                                                index,
                                                date,
                                                "FromTime",
                                                1
                                            );
                                        }}
                                        format="h:mm a"
                                        use12Hours
                                    />
                                </div>
                                <div className={dashboardclasses["slots_item"]}>
                                    <label htmlFor="">To Time</label>
                                    <TimePicker
                                        placement={"topLeft"}
                                        value={moment(item.ToTime, "HH:mm")}
                                        defaultOpenValue={moment()}
                                        // focusOnOpen={true}
                                        minuteStep={5}
                                        allowEmpty={false}
                                        showSecond={false}
                                        onChange={(date) => {
                                            handleTimeChange(
                                                index,
                                                date,
                                                "ToTime",
                                                1
                                            );
                                        }}
                                        format="h:mm a"
                                        use12Hours
                                    />
                                </div>
                                {/* {index > 0 && (
                                   
                                )} */}
                                <button
                                    type="button"
                                    className={
                                        dashboardclasses["slot_Delete_Handler"]
                                    }
                                    onClick={() => removeSlot(index, 1)}>
                                    <AiOutlineClose size={12} />
                                </button>
                            </div>
                        ))}
                    </div>

                    <div
                        ref={slot2}
                        className={dashboardclasses["Slots-Container"]}>
                        <button
                            Type="button"
                            onClick={() => {
                                addslot(2);
                            }}
                            className={dashboardclasses["add_slot"]}>
                            Add Slot
                        </button>
                        <label htmlFor="">Tomorrow</label>
                        {Time2.map((item, index) => (
                            <div className={dashboardclasses["slots_input"]}>
                                <div className={dashboardclasses["slots_item"]}>
                                    <label htmlFor="">From Time</label>
                                    <TimePicker
                                        placement={"topLeft"}
                                        // onOpen={checkStartDate}
                                        value={moment(item.FromTime, "HH:mm")}
                                        defaultOpenValue={moment()}
                                        // focusOnOpen={true}
                                        minuteStep={5}
                                        allowEmpty={false}
                                        showSecond={false}
                                        onChange={(date) => {
                                            handleTimeChange(
                                                index,
                                                date,
                                                "FromTime",
                                                2
                                            );
                                        }}
                                        format="h:mm a"
                                        use12Hours
                                    />
                                </div>
                                <div className={dashboardclasses["slots_item"]}>
                                    <label htmlFor="">To Time</label>
                                    <TimePicker
                                        placement={"topLeft"}
                                        // onOpen={checkStartDate}
                                        value={moment(item.ToTime, "HH:mm")}
                                        defaultOpenValue={moment()}
                                        // focusOnOpen={true}
                                        minuteStep={5}
                                        allowEmpty={false}
                                        showSecond={false}
                                        onChange={(date) => {
                                            handleTimeChange(
                                                index,
                                                date,
                                                "ToTime",
                                                2
                                            );
                                        }}
                                        format="h:mm a"
                                        use12Hours
                                    />
                                </div>
                                {/* {index > 0 && (
                                  
                                )} */}
                                <button
                                    type="button"
                                    className={
                                        dashboardclasses["slot_Delete_Handler"]
                                    }
                                    onClick={() => removeSlot(index, 2)}>
                                    <AiOutlineClose size={12} />
                                </button>
                            </div>
                        ))}
                    </div>
                    <div
                        ref={slot3}
                        className={dashboardclasses["Slots-Container"]}>
                        <button
                            Type="button"
                            onClick={() => {
                                addslot(3);
                            }}
                            className={dashboardclasses["add_slot"]}>
                            Add Slot
                        </button>
                        <label htmlFor="">Day After</label>
                        {Time3.map((item, index) => (
                            <div className={dashboardclasses["slots_input"]}>
                                <div className={dashboardclasses["slots_item"]}>
                                    <label htmlFor="">From Time</label>
                                    <TimePicker
                                        placement={"topLeft"}
                                        // onOpen={checkStartDate}
                                        value={moment(item.FromTime, "HH:mm")}
                                        defaultOpenValue={moment()}
                                        // focusOnOpen={true}
                                        minuteStep={5}
                                        allowEmpty={false}
                                        showSecond={false}
                                        onChange={(date) => {
                                            handleTimeChange(
                                                index,
                                                date,
                                                "FromTime",
                                                3
                                            );
                                        }}
                                        format="h:mm a"
                                        use12Hours
                                    />
                                </div>
                                <div className={dashboardclasses["slots_item"]}>
                                    <label htmlFor="">To Time</label>
                                    <TimePicker
                                        placement={"topLeft"}
                                        // onOpen={checkStartDate}
                                        value={moment(item.ToTime, "HH:mm")}
                                        defaultOpenValue={moment()}
                                        // focusOnOpen={true}
                                        minuteStep={5}
                                        allowEmpty={false}
                                        showSecond={false}
                                        onChange={(date) => {
                                            handleTimeChange(
                                                index,
                                                date,
                                                "ToTime",
                                                3
                                            );
                                        }}
                                        format="h:mm a"
                                        use12Hours
                                    />
                                </div>
                                {/* {index > 0 && (
                                   
                                )} */}
                                <button
                                    type="button"
                                    className={
                                        dashboardclasses["slot_Delete_Handler"]
                                    }
                                    onClick={() => removeSlot(index, 3)}>
                                    <AiOutlineClose size={12} />
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "Update Slot" : "Add Slot"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
